// MANAGER VIEW ACTIONS
import { Loading } from 'JBSrc/constants';
import { sessionFlash } from 'JBSrc/session-flash';
import { scrollTo } from 'JBPlugin/scroll-to';
import { executiveTableAdjust, fieldLogic } from 'JBSrc/field-logic';

jQuery($ => {

	// TABLE SORTING
	$(document).on('click', '.column-sortable [data-sort-field]', function(e){
		e.preventDefault();
		let $form = $(this).closest('.card').find('.filterCollection');
		$form.find('input[name="sort"]').val($(this).attr('data-sort-field'));
		$form.find('input[name="order"]').val($(this).attr('data-sort-order'));
		$form.submit();
	});

	//Exporting Results
	$(document).on('click', '.filterCollection .exportResults', function(e){
		e.preventDefault();
		let $form = $(this).closest('.filterCollection');
		$form.attr('action', $(e.target).attr('href'));
		$form.submit();
	});

	//Approve/Deny club request
	$(document).on('click', '.alterClubRequest', function(e){
		e.preventDefault();
		if($(this).hasClass('disabled')){
			return false;
		}
		let href = $(this).attr('href');
		let redirect = $(this).data('redirect') ? $(this).data('redirect') : null;
		let type = $(this).data('type');
		let comments = $(this).data('comments') ? $($(this).data('comments')).val() : '';
		let parent = $(this).parent();
		if(confirm('Are you sure you\'d like to ' + type + ' this request?')){
			$('.alterClubRequest').addClass('disabled').append(Loading.icon);
			$.post(href, { _token: window.csrf_token, comments: comments }, function(data){
				parent.find('.loading').remove();
				if(data.redirect !== null){
					sessionFlash(data.message, data.success, 3000, data.redirect);
				}else{
					sessionFlash(data.message, data.success);

					if(data.success){
						setTimeout(function(){
							window.location.reload();
						}, 3000);
					}
				}
			},'json');
		}
	});

	//Grant/Revoke event submission access
	$(document).on('click', '.updateEmpAccess', function(e){
		e.preventDefault();
		let href = $(this).attr('href');
		let type = $(this).data('type');
		let student_id = $(this).data('studentId');
		$.post(href, {
			_token: window.csrf_token,
			student_id: student_id,
			type: type
		}, function(data){
			//it will redirect in the action serverside
			sessionFlash(data.message, data.success, 3000, window.location.href);
		},'json').fail(function() {
			sessionFlash('There was an error processing your request', 0);
		});
	});

	//Better table handling for managers on mobile
	//executiveTableAdjust();
	//window.addEventListener('resize', _.throttle(executiveTableAdjust, 500));

	$('.table--executive').each(function(){
		if($(this).find('.no-results').length){
			let headerCols = $(this).find('th').length;
			$(this).find('.no-results td:first').attr('colspan', headerCols);
			$(this).addClass('table--no-results')
		}
	});

	//Process Uploaded Members for review
	$(document).on('submit', '#clubMemberUpload', function(e){
		e.preventDefault();
		let form = $(this);
		let formData = new FormData(this);

		$('#processedMembers').html(Loading.default_navy);
		$.ajax({
			url: form.attr('action'),
			type: 'POST',
			data: formData,
			success: function (data) {
				$('#processedMembers').html(data);
				fieldLogic();
				processMembersCheck();
				scrollTo('#processedMembers');
			},
			cache: false,
			contentType: false,
			processData: false
		});
	});
	function processMembersCheck(){
		let total = $('#processedMembers td input[type=checkbox]').length;
		let checked = $('#processedMembers td input[type=checkbox]:checked').length;
		$('.membersSelectedCount').text(checked);
		$('.membersUnSelectedCount').text(total - checked);
	}
	$(document).on('change', '#processedMembers #selectall', function(){
		if($(this).is(':checked')){
			$('#processedMembers td input[type=checkbox]').prop('checked', true);
		}else{
			$('#processedMembers td input[type=checkbox]').prop('checked', false);
		}
		processMembersCheck();
	});
	$(document).on('change', '#processedMembers td input[type=checkbox]', function(){
		processMembersCheck();
	});
	$(document).on('submit', '#processedMembersList', function(){
		let form = $(this);

		//check at least 1 member is selected
		let errors = [];
		if($('#processedMembers td input[type=checkbox]:checked').length <= 0){
			errors.push('You need to select at least 1 member to import.');
		}

		//No errors
		if(errors.length === 0){
			//set csrf_token
			$('input[name="_token"]').val(window.csrf_token);

			let selected_members = [];
			$('#processedMembers td input[type=checkbox]:checked').each(function(){
				selected_members.push($(this).val());
			});
			//Convert member selected into JSON
			$('#membersSelected').val(JSON.stringify(selected_members));
		}else{
			sessionFlash(errors.join('<br />'), false);
			return false;
		}
	});
});
